import { queryProindexInfo, queryDownloadFilePriceByRecordId, queryOpennumberInfo } from '@/api/home'
import { createOrder } from "@/api/common"

import lookPre from "../components/lookPre.vue"
import showDetail from '../components/showDetail.vue'
import viewHistory from '../components/viewHistory.vue'
export default {

	components: { showDetail, lookPre, viewHistory },
	computed: {
		showPriceWord () {
			return function (str, type) {
				if (str) {
					if (type === 'coin') {
						let obj = JSON.parse(str)
						// console.log('obj', obj);
						return obj[type] ? obj[type] + '缩币' : '免费'
					}
					if (type === 'is_win') {
						let obj = JSON.parse(str)
						let arr = ['', '是', '否']
						return arr[obj[type]]
					}
					if (type === 'real_bet_number') {
						let obj = JSON.parse(str)
						return obj[type] * 1 || ''
					}
					if (type === 'free') {
						let obj = JSON.parse(str)
						return !!(obj['coin'] * 1)
					}
				}
			}
		},
	},
	data () {
		return {
			tableLoading: false,
			ListPagin1: {},

			detailTitle: {},
		}
	},
	mounted () {
	},
	filters: {
	},
	methods: {

		// 选择文件
		chooseFile(event){
			console.log('chooseFile');
			const file = event.target.files[0];
			const reader = new FileReader();
			reader.readAsText(file);
			reader.onload = (e) => {
				const content = e.target.result;
				const res = JSON.parse(content);
				this.init(res);
			};
		},

		// 查看历史记录
		view_history (item, preType,) {
			// localStorage.setItem("dating_viewHistory_params", JSON.stringify(item))
			// console.log('item',JSON.parse(JSON.stringify(item)));
			this.$router.push({
				path: '/dating_viewHistory',
				query: {
					shrinkId: item.shrinkId || item.createUser,
					number: item.number,
					userName: item.nickName,
					preType,
				}
			})
		},

		// 查看详情
		preDetail (item, preIndexLabel, type) {
			this.$refs.showDetail.init(item, preIndexLabel, type)
		},

		handleDownload (item, preIndexType, indexName, preIndexTypeLabel) {

			console.log('preIndexType', preIndexType);
			console.log('item', JSON.parse(JSON.stringify(item)));
			console.log('indexName', indexName);
			console.log('preIndexTypeLabel', preIndexTypeLabel);
			let { preType, number, shrinkId, createUser } = item;

			this.detailTitle = {
				preType,
				indexName,
			}

			let id = shrinkId ?? createUser ?? null;
			// let { preType, number, shrinkId } = item
			let params = { preType, preIndexType, number, createUser: id, }
			console.log('page - downloadFile - params', JSON.parse(JSON.stringify(params)));

			let isview = ['杀6蓝', '围4蓝', '杀5后', '围3后'].includes(indexName)

			new Promise((resolve, reject) => {
				this.$http.post('/stage-api/pre/record/queryDownloadFilePriceByRecordId', params).then(res => resolve(res.data))
			}).then(async res => {
				console.log('查询下载预测文件所需价格 - res', res);
				let { orderNo, price, productId, specsId, status } = res

				localStorage.setItem("payStatus", isview ? 'look' : 'pay')

				// isview:true = 查阅
				if (isview) {
					if (orderNo && status.value === '1') {
						this.preView(price, orderNo, indexName)
					} else {

						let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
						if (!resCreateOrder) {
							return;
						}

						this.$nextTick(() => {
							this.preView(price, resCreateOrder, indexName)
						})

					}
				} else {
					console.log('orderNoorderNoorderNoorderNoorderNo', orderNo, status);
					if (orderNo && status.value === '1') {
						// 下载文件
						this.downloadFile(orderNo, price, item, preIndexTypeLabel)
					} else {
						// let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
						// if (!resCreateOrder) {
						// 	return;
						// }
						// console.log('resCreateOrder----------------', resCreateOrder);

						// 下载文件
						//this.downloadFile(resCreateOrder, price, item, preIndexTypeLabel)

						if (price) {
							let payDb = {
								avatar: process.env.VUE_APP_BASE_API + 'stage-api' + item.avatar,
								title: item.title,
								nickName: item.nickName,
								number: item.number,
								shrinkId: item.shrinkId,
								indexName: item.indexName,
								strJson: JSON.parse(item[preIndexTypeLabel]),
								lotteryType: item.preType,
								price, productId, specsId,
							}
							this.$emit('view_download', payDb)
						} else {
							let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
							if (!resCreateOrder) {
								return;
							}
							// 下载文件
							this.downloadFile(resCreateOrder, price, item, preIndexTypeLabel)
						}

					}
				}


			})


		},

		// 下载文件
		downloadFile (orderNo, price, item, preIndexTypeLabel) {
			let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
			let that = this

			this.$confirm('您确定下载该缩水单吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.get('/stage-api/pre/detail/zipDownload', {
					params: { orderNo, coin: price },
					headers: { 'Authorization': 'Bearer ' + this.vuex_token },
					responseType: 'blob',
					onDownloadProgress: (progressEvent) => {
						const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						that.$vuex('vuex_downFile_progress', percentCompleted >= 100 ? false : percentCompleted)
					},
				}).then(downRes => {
					if (downRes.code == 500) { return this.$message.error(res.msg) }
					console.log('preIndexTypeLabel', preIndexTypeLabel);
					let real_bet_number = JSON.parse(item[preIndexTypeLabel]).real_bet_number
					let fileName = `${lotteryType[item.preType * 1]}-${item.number}期-${item.nickName}-${real_bet_number}.zip`
					this.$utils.downloadFile(downRes, fileName, 'application/zip')
				})
			});
		},

		// 创建订单
		async fun_createOrder (price, item, productId, specsId) {
			let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
			// 创建订单号
			let params = {
				money: price,
				productAuthor: item.shrinkId,	//商家id
				productId,
				productSpecsId: specsId,
				payType: 'balancepay',
				productModel: 0,
				quantity: 1,
				title: `${lotteryType[item.preType * 1]} - ${item.nickName} - ${item.number}`,
				uuid: new Date().getTime(),
			}

			console.log('params----------', params);

			let resCreateOrder = await createOrder(params)
			if (resCreateOrder.code == 500) {
				this.$message.error(resCreateOrder.msg)
				return null;
			}
			console.log('resCreateOrder', resCreateOrder);

			return resCreateOrder.data.orderNo
		},

		// 免费和收费查看彩种额外指标  (点击了查阅按钮)
		preView (price, orderNo, indexName) {
			this.$http.get('/stage-api/pre/detail/additional/indicators', {
				params: {
					coin: price,
					orderNo,
					pageNum: 1,
					pageSize: 10,
				}
			}).then(res => {
				console.log('免费和收费查看彩种额外指标 - res', res);

				if (res.code == 500) {
					return this.$message.error(res.msg)
				}
				this.$refs.lookPre.init({ ...res, ...this.detailTitle })
				this.$emit('look_downFile', res)
			})
		}
	}
}
